import React from 'react';
import { styled, css, useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

export interface ISvg extends IIcon {
  direction?: 'left' | 'right' | 'top' | 'bottom';
}

const Svg = styled.svg`
  ${({ direction }) =>
    direction === 'right' &&
    css`
      transform: rotate(-180deg);
    `}
  ${({ direction }) =>
    direction === 'top' &&
    css`
      transform: rotate(90deg);
    `}
  ${({ direction }) =>
    direction === 'bottom' &&
    css`
      transform: rotate(-90deg);
    `}
`;

const Icon = React.forwardRef<SVGSVGElement | null, ISvg>(function Icon({ size = 24, alt, color, className, onClick, direction }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <Svg
      ref={ref}
      onClick={onClick}
      width={size}
      direction={direction}
      height={size}
      viewBox='0 0 1792 1792'
      fill='none'
      className={className}>
      <path
        d='M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z'
        fill={fillColor}
      />
    </Svg>
  );
});

export default React.memo(Icon);
